"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var items = [
    { form_id: "enrollment_agreement", title: "Enrollment Agreement" },
    { form_id: "signature_certificate", title: "Signature Certificate" }
];
var IndexPage = (function (_super) {
    __extends(IndexPage, _super);
    function IndexPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndexPage.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h1", null, "Forms:"),
            items.map(function (item, index) {
                return (React.createElement(Li, { title: item.title, form_id: item.form_id, index: index, key: index }));
            })));
    };
    return IndexPage;
}(react_1.Component));
exports.IndexPage = IndexPage;
function Li(_a) {
    var index = _a.index, form_id = _a.form_id, title = _a.title;
    var url = "/?form_id=" + form_id;
    var pdf_url = url + "&pdf";
    return (React.createElement("div", { style: { marginBottom: "10px" } },
        React.createElement("strong", null,
            index + 1,
            ". "),
        React.createElement("a", { href: url }, title),
        " (",
        React.createElement("a", { href: pdf_url }, "PDF"),
        ")"));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5kZXhQYWdlLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvSW5kZXhQYWdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUkvQixJQUFNLEtBQUssR0FBRztJQUNWLEVBQUMsT0FBTyxFQUFFLHNCQUFzQixFQUFFLEtBQUssRUFBRSxzQkFBc0IsRUFBQztJQUNoRSxFQUFDLE9BQU8sRUFBRSx1QkFBdUIsRUFBRSxLQUFLLEVBQUUsdUJBQXVCLEVBQUM7Q0FDckUsQ0FBQTtBQUVEO0lBQStCLDZCQUFvQjtJQUFuRDs7SUFhQSxDQUFDO0lBWlUsMEJBQU0sR0FBYjtRQUNJLE9BQU8sQ0FDSDtZQUNJLHlDQUFlO1lBQ2QsS0FBSyxDQUFDLEdBQUcsQ0FBQyxVQUFDLElBQUksRUFBRSxLQUFLO2dCQUNuQixPQUFPLENBQ0gsb0JBQUMsRUFBRSxJQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSyxFQUFFLE9BQU8sRUFBRSxJQUFJLENBQUMsT0FBTyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsR0FBRyxFQUFFLEtBQUssR0FBSSxDQUM3RSxDQUFBO1lBQ0wsQ0FBQyxDQUFDLENBQ0EsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQUNMLGdCQUFDO0FBQUQsQ0FBQyxBQWJELENBQStCLGlCQUFTLEdBYXZDO0FBYlksOEJBQVM7QUFldEIsU0FBUyxFQUFFLENBQUMsRUFBd0U7UUFBdkUsZ0JBQUssRUFBRSxvQkFBTyxFQUFFLGdCQUFLO0lBQzlCLElBQU0sR0FBRyxHQUFHLGVBQWEsT0FBUyxDQUFBO0lBQ2xDLElBQU0sT0FBTyxHQUFNLEdBQUcsU0FBTSxDQUFBO0lBQzVCLE9BQU8sQ0FDSCw2QkFBSyxLQUFLLEVBQUUsRUFBQyxZQUFZLEVBQUUsTUFBTSxFQUFDO1FBQzlCO1lBQVMsS0FBSyxHQUFHLENBQUM7aUJBQVk7UUFDOUIsMkJBQUcsSUFBSSxFQUFFLEdBQUcsSUFBRyxLQUFLLENBQUs7O1FBQUUsMkJBQUcsSUFBSSxFQUFFLE9BQU8sVUFBUztZQUNsRCxDQUNULENBQUE7QUFDTCxDQUFDIn0=